const KEY = "tb_dashboard_toast_v1";

export function setDashboardToast(message, type = "success") {
    try {
        const payload = {
            type: type || "success",
            message: message || "",
            ts: Date.now(),
        };
        sessionStorage.setItem(KEY, JSON.stringify(payload));
    } catch {
        // ignore (storage disabled)
    }
}

export function peekDashboardToast() {
    try {
        const raw = sessionStorage.getItem(KEY);
        if (!raw) return null;
        const parsed = JSON.parse(raw);
        if (!parsed || typeof parsed !== "object") return null;
        return parsed;
    } catch {
        return null;
    }
}

export function clearDashboardToast() {
    try {
        sessionStorage.removeItem(KEY);
    } catch {
        // ignore
    }
}

// Back-compat name (older code may import this)
export function consumeDashboardToast() {
    const v = peekDashboardToast();
    clearDashboardToast();
    return v;
}
